import http from "./http";

// 登录
export function login(data = {}) {
  return new Promise((resolve, reject) => {
    http.post("/login", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 退出登录
export function logonOut() {
  return new Promise((resolve, reject) => {
    http.post("/logout").then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 注册
export function register(data = {}) {
  return new Promise((resolve, reject) => {
    http.post("/register", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 默认注册角色位学生
export function register_stu(id, data = {}) {
  return new Promise((resolve, reject) => {
    http.post("/register?school_id=" + id, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 获取用户角色
export function get_userRole_api() {
  return new Promise((resolve, reject) => {
    http.get("/rbac/subject/pred").then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
